<!-- 头部-->
<template>
  <div class="headcontent">
    <List item-layout="vertical">
      <ListItem>
        <ListItemMeta>
          <template slot="avatar">
            <div @click="openProfile(headInfo.dingdingUserId)" class="user-avatar">
              <img
                :src="headInfo.headUrl&&headInfo.headUrl.length>0?headInfo.headUrl:require('@/assets/images/defaultHead.png')"
              />
            </div>
          </template>
          <template slot="title">
            <span class="username">{{headInfo.userName}}</span>
          </template>
          <template slot="description">
            <div class="description-item">
              <span class="status" :class="'state-img-'+headInfo.approvalState"></span>
              <span v-if="headInfo.approvalState=='APPRYES'">审批通过</span>
              <span v-else-if="headInfo.approvalState=='APPRNO'">审批不通过</span>
              <span v-else>等待{{headInfo.approver}}审批</span>
            </div>
          </template>
        </ListItemMeta>
      </ListItem>
    </List>
  </div>
</template>
<script>
import * as dd from "dingtalk-jsapi";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      dingdingconfig: state => state.dingdingconfig
    })
  },
  props: {
    headInfo: {
      type: Object,
      default() {
        return { headUrl: "", userName: "", approver: "", approvalState: "" };
      }
    }
  },
  methods: {
    openProfile(dingdingUserId) {
      if (dingdingUserId.length > 0) {
        let _this = this;
        dd.biz.util.open({
          name: "profile", //页面名称
          params: { id: dingdingUserId, corpId: _this.dingdingconfig.corpId }, //传参
          onSuccess: function() {
            /**/
          },
          onFail: function(err) {}
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.headcontent {
  display: flex;
  width: 100%;
  height: 2.72rem;
  align-items: center;
  /deep/.ivu-list-item-meta {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 0;
  }
  .user-avatar {
    text-align: center;
    white-space: nowrap;
    position: relative;
    vertical-align: middle;
    width: 1.44rem;
    height: 1.44rem;
    overflow: hidden;
    line-height: 1.3333rem;
    border-radius: 50%;
    border: 0.04rem solid #fff;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .username {
    font-size: 0.4533rem;
    color: #fff;
  }
  .description-item {
    font-size: 0.3467rem;
    color: #fff9ed;
    line-height: 0.3467rem;
    .state-img-SUBMIT {
      background: url("../../../assets/icon/icon-dengdai.png") no-repeat;
    }

    .state-img-APPRYES {
      background: url("../../../assets/icon/icon-tongguo.png") no-repeat;
    }

    .state-img-APPRNO {
      background: url("../../../assets/icon/icon-shibai.png") no-repeat;
    }
    .status {
      height: 0.3467rem;
      width: 0.3467rem;
      display: inline-block;

      background-size: 100% 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalHead/index.vue